import { Fragment, type PropsWithChildren, type ReactNode } from 'react';

export interface RenderIfCompProps {
  /** Condition to render the child */
  condition: string | number | boolean | object | null | undefined,
  /** Fallback element if `condition` is false */
  fallback?: ReactNode,
}

/**
 * A component that render the child if the given `condition` props is true,
 * otherwise render nothing or `fallback`
 *
 * Used to avoid using excessive ternary (eg. `a ? (b ? c : d) : e`)
 */
export function RenderIf(props: PropsWithChildren<RenderIfCompProps>): ReactNode {
  if (props.condition) {
    return (
      <Fragment>
        {props.children}
      </Fragment>
    );
  }

  if (props.fallback !== null || props.fallback !== undefined) {
    return (
      <Fragment>
        {props.fallback}
      </Fragment>
    );
  }

  return null;
}
